export const KeyCodes={ao:32,oo:9,io:13,xi:27};